(function () {
    'use strict';

    // Homepage hero "Check my reg". The form posts to Van Health (?handler=Show), which runs the lookup and
    // renders its page with the result already in it. Like every public DVLA lookup it needs a Turnstile token.
    //
    // Cloudflare's api.js is NOT loaded with the page: the homepage is the page PageSpeed is judged on, and most
    // visitors never touch the box. It loads on the first interaction with the form, and the widget solves while
    // the reg is being typed (appearance: interaction-only, so usually nothing is shown). A submit that lands
    // before a token is ready is held and sent the moment one arrives.
    //
    // If no token ever comes (blocked script, a challenge nobody answers), the form is sent anyway after a
    // while: Van Health then shows "Security check failed" with the reg already in its own box, where its normal
    // Check button can try again. No lookup runs without a token either way.
    //
    // The one exception is Cloudflare asking for a tick (turnstile-tick.js). Giving up after 12 seconds then only
    // sent them to "Security check failed", so instead the box says what to do and the reg goes the moment the
    // tick does.
    const FORM_SELECTOR = '[data-hero-reg]';
    const CONTAINER_ID  = 'cf-turnstile-container-hero';
    const INPUT_ID      = 'cf-turnstile-response-hero';
    const API_SRC       = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    const GIVE_UP_MS    = 12000;
    // While the lookup runs the chevron becomes a UK roundabout sign — three arrows chasing clockwise — spinning.
    const ROUNDABOUT    = '<svg class="syv-roundabout" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M19.05 14.57A7.5 7.5 0 0 1 12.26 19.50"/><path d="M9.06 19.61L12.35 22.09L12.17 16.90Z" fill="currentColor" stroke="none"/><path d="M6.25 16.82A7.5 7.5 0 0 1 5.38 8.48"/><path d="M6.88 5.65L3.08 7.26L7.67 9.70Z" fill="currentColor" stroke="none"/><path d="M10.70 4.61A7.5 7.5 0 0 1 18.36 8.03"/><path d="M20.06 10.74L20.57 6.65L16.16 9.40Z" fill="currentColor" stroke="none"/></svg>';

    const form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    const reg       = form.querySelector('input[name="VehicleRegistration.Registration"]');
    const button    = form.querySelector('button[type="submit"]');
    const container = document.getElementById(CONTAINER_ID);
    const errorEl   = document.getElementById('hero-reg-error');
    const hintEl    = document.getElementById('hero-reg-hint');

    let loadStarted = false;
    let tokenReady  = false;
    let pending     = false;
    let giveUpTimer = null;
    let needsTick   = false;

    function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
    }

    function clearError() {
        if (errorEl) errorEl.hidden = true;
    }

    function setBusy(busy) {
        if (!button) return;
        if (busy) {
            if (!button.dataset.label) button.dataset.label = button.innerHTML;
            button.innerHTML = ROUNDABOUT;
            button.setAttribute('aria-busy', 'true');
        } else {
            if (button.dataset.label) button.innerHTML = button.dataset.label;
            button.removeAttribute('aria-busy');
        }
    }

    function send() {
        pending = false;
        if (giveUpTimer) { clearTimeout(giveUpTimer); giveUpTimer = null; }
        setBusy(true);
        form.submit();   // does not fire 'submit' again
    }

    function showHint(show) {
        if (hintEl) hintEl.hidden = !show;
    }

    // Cloudflare wants a tick: stop the clock, stop the spinner (nothing is happening until they tick), say so,
    // and bring the box into view - on a phone it can sit below the fold.
    function askForTick() {
        if (needsTick || tokenReady) return;
        needsTick = true;
        if (giveUpTimer) { clearTimeout(giveUpTimer); giveUpTimer = null; }
        setBusy(false);
        showHint(true);
        if (container && container.scrollIntoView) container.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function tickBoxShowing() {
        return window.SyvTurnstileTick.showing(container);
    }

    function renderWidget() {
        if (!container || !window.SmaoinTurnstile) return;
        window.SmaoinTurnstile.render(container, INPUT_ID, {
            action: 'vehicle-lookup',
            onToken: function () {
                tokenReady = true;
                needsTick = false;
                showHint(false);
                if (pending) send();
            },
            onExpire: function () { tokenReady = false; },
            onFail: function () { tokenReady = false; }
        });
        window.SyvTurnstileTick.watch(container, askForTick);
    }

    function load() {
        if (loadStarted) return;
        loadStarted = true;

        if (typeof window.turnstile !== 'undefined') {
            renderWidget();
            return;
        }
        const script = document.createElement('script');
        script.src = API_SRC;
        script.async = true;
        script.onload = renderWidget;
        // Blocked outright (ad-blocker, network filter): nothing will ever arrive, so a held submit goes now.
        script.onerror = function () { if (pending) send(); };
        document.head.appendChild(script);
    }

    ['focusin', 'pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
        form.addEventListener(type, load, { once: true, passive: true });
    });

    form.addEventListener('submit', function (e) {
        clearError();
        if (!reg || !reg.value.trim()) {
            e.preventDefault();
            showError('Enter your registration first.');
            if (reg) reg.focus();
            return;
        }

        const token = document.getElementById(INPUT_ID);
        if (tokenReady && token && token.value) { setBusy(true); return; }   // ready: let the browser post it

        e.preventDefault();
        pending = true;
        load();
        if (needsTick) { showHint(true); return; }   // waiting on their tick - the token sends it
        setBusy(true);
        // A browser that wasn't drawing the page never reports the box appearing (measured 2026-11-02), so look
        // again before giving up: a tick box on screen means ask for the tick, not post without a token.
        giveUpTimer = setTimeout(function () {
            if (!pending || needsTick) return;
            if (tickBoxShowing()) { askForTick(); return; }
            send();
        }, GIVE_UP_MS);
    });

    // Back from Van Health: the bfcache restores this page mid-"Checking…". Reset it, and get a fresh token —
    // the one that was sent has been spent.
    window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        setBusy(false);
        pending = false;
        tokenReady = false;
        needsTick = false;
        showHint(false);
        const token = document.getElementById(INPUT_ID);
        if (token) token.value = '';
        if (loadStarted && typeof window.turnstile !== 'undefined' && container) {
            try { window.turnstile.reset(container); } catch (err) { /* widget gone; next load re-renders */ }
        }
    });
}());
